import {reject} from 'lodash';

/**
 * Returns all paragraphs in a given Paper.
 * Remove paragraphs that do not contain sentences or only consist of links.
 *
 * @param {Paper} paper The current paper.
 * @returns {Paragraph[]} All paragraphs in the paper.
 */
export default function(paper) {
  let paragraphs = paper.getTree().findAll(node => node.name === 'p');

  // Remove empty paragraphs without sentences and paragraphs only consisting of empty links.
  paragraphs = reject(paragraphs, paragraph => paragraph.sentences.length === 0);
  // Don't remove paragraphs with links that contain meaningful text
  paragraphs = reject(paragraphs, paragraph => {
    // Only reject if ALL children are links AND those links are empty/meaningless
    const allLinks = paragraph.childNodes.every(node => node.name === 'a');
    if (!allLinks) return false;

    // Check if the paragraph has meaningful text content
    const textContent = paragraph.innerText().trim();
    return textContent.length === 0; // Only reject if completely empty
  });

  return paragraphs;
}
